import {BrowserModule} from '@angular/platform-browser';
import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';

import {AppComponent} from './app.component';
import {PortfolioComponent} from './portfolio/portfolio.component';
import {PortfolioItemComponent} from './portfolio/portfolio-item.component';
import {PortfolioService} from "./portfolio/portfolio-service.service";
import {SafeUrlPipe} from './safe-url.pipe';
import {AboutComponent} from './about/about.component';
import {ContactComponent} from './contact/contact.component';
import {RouterModule} from "@angular/router";
import {routes} from "./routes";
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {DatePipe, HashLocationStrategy, LocationStrategy} from "@angular/common";
import {GoogleAnalyticsEventsService} from "./google-analytics-service";
import {BlogComponent} from './blog/blog.component';
import {BlogService} from "./blog.service";
import {BlogHomeComponent} from "./blog/blog-home.component";
import {BlogItemComponent} from "./blog/blog-item.component";
import {HttpClientModule} from "@angular/common/http";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {ModalSelectTechsComponent} from './modal-select-techs/modal-select-techs.component';
import {FormsModule} from "@angular/forms";

@NgModule({
    declarations: [
        AppComponent,
        PortfolioComponent,
        PortfolioItemComponent,
        SafeUrlPipe,
        AboutComponent,
        ContactComponent,
        PageNotFoundComponent,
        BlogComponent,
        BlogHomeComponent,
        BlogItemComponent,
        ModalSelectTechsComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        RouterModule.forRoot(routes),
        NgbModule.forRoot(),
        FormsModule
    ],
    schemas: [NO_ERRORS_SCHEMA],
    providers: [
        PortfolioService,
        BlogService,
        GoogleAnalyticsEventsService,
        DatePipe,
        {provide: LocationStrategy, useClass: HashLocationStrategy}],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts